import { Component, Input } from '@angular/core';
import { FairsConfiguration } from '@planone/bau365/util-fair-data';

@Component({
  selector: 'bau365-shell-mobile-bottom-bar',
  templateUrl: './mobile-bottom-bar.component.html',
  styleUrls: ['./mobile-bottom-bar.component.scss'],
})
export class MobileBottomBarComponent {
  @Input() configuration: FairsConfiguration | undefined | null;
  @Input() isLoggedIn: boolean | undefined | null;
  @Input() qrCodeScannerEnabled: boolean | undefined | null;
  @Input() ticketsEnabled: boolean | undefined | null;
}
